import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Mention = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 8C3 5.23858 5.23858 3 8 3C10.7614 3 13 5.23858 13 8V9.05086C13 9.78391 12.6253 10.4701 12.0084 10.8689C11.8762 10.9543 11.7217 11 11.5651 11C11.1149 11 10.75 10.6351 10.75 10.1849V9.12498V8.20831V5.5H9.75V6.0288C9.24661 5.59535 8.59141 5.33331 7.875 5.33331C6.28718 5.33331 5 6.62049 5 8.20831V9.12498C5 10.7128 6.28718 12 7.875 12C8.7087 12 9.45952 11.6451 9.98465 11.0782C10.2964 11.6286 10.8874 12 11.5651 12C11.9151 12 12.258 11.8983 12.5513 11.7087C13.4519 11.1265 14 10.1248 14 9.05086V8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8V8.84076C2 12.2452 4.78516 15 8.18398 15C9.26467 15 10.3385 14.7552 11.3119 14.2832L10.8756 13.3834C10.0392 13.789 9.11457 14 8.18398 14C5.33176 14 3 11.6873 3 8.84076V8ZM9.75 9.12498V8.20831C9.75 7.17278 8.91053 6.33331 7.875 6.33331C6.83947 6.33331 6 7.17278 6 8.20831V9.12498C6 10.1605 6.83947 11 7.875 11C8.91053 11 9.75 10.1605 9.75 9.12498Z"
        fill={color}
      />
    </svg>
  )
})

export default Mention
